<div id="header" >
    <h1 (mouseenter)="onHover()" (mouseout)="onExit()" [ngStyle]="id">English Dictionary</h1>
</div>
